/**
 * Glass Cards — crossfade container background on card hover.
 *
 * Two stacked media layers (A on top, B beneath) swap visibility via opacity.
 * This avoids the browser's background-image snap/scale artifact that occurs
 * when transitioning the background-image property directly.
 */
document.querySelectorAll('.pattern-glass-cards').forEach((section) => {
  const layerA = section.querySelector('.container-media--a');
  const layerB = section.querySelector('.container-media--b');
  const cards  = section.querySelectorAll('.glass-card[data-image]');

  if (!layerA || !layerB || !cards.length) return;

  // Track which layer is currently on top
  let topLayer    = layerA;
  let bottomLayer = layerB;

  const defaultImage = layerA.style.backgroundImage;
  const defaultPos   = layerA.style.backgroundPosition;

  function crossfadeTo(imageUrl, pos) {
    // Prepare the bottom layer with the new image (invisible, beneath)
    bottomLayer.style.backgroundImage    = imageUrl;
    bottomLayer.style.backgroundPosition = pos;

    // Fade top layer out — bottom layer (new image) shows through
    topLayer.classList.remove('is-active');
    bottomLayer.classList.add('is-active');

    // Swap roles for the next transition
    [topLayer, bottomLayer] = [bottomLayer, topLayer];
  }

  cards.forEach((card) => {
    card.addEventListener('mouseenter', () => {
      crossfadeTo(`url('${card.dataset.image}')`, card.dataset.pos);
    });
  });

  section.addEventListener('mouseleave', () => {
    crossfadeTo(defaultImage, defaultPos);
  });
});
